import { Check } from "lucide-react";
import { Reveal } from "./Reveal";

const packages = [
  {
    name: "60-Minute Lesson",
    price: "$80",
    per: "single lesson",
    featured: false,
    features: ["Perfect for building skills and confidence", "Pick-up & drop-off included", "Lesson debrief & goal setting"],
  },
  {
    name: "90-Minute Lesson",
    price: "$110",
    per: "single lesson",
    featured: false,
    features: ["More time. More learning. More progress", "Pick-up & drop-off included", "Parent feedback after the lesson"],
  },
  {
    name: "2-Hour Lesson",
    price: "$150",
    per: "single lesson",
    featured: false,
    features: ["Ideal for bigger goals", "Real road experience, not just laps", "Pick-up & drop-off included"],
  },
  {
    name: "5 × 1HR Package",
    price: "$375",
    per: "save $25",
    featured: true,
    features: ["Great value, consistent learning", "All standard inclusions, every lesson", "Stronger results week on week"],
  },
];

export default function Packages() {
  return (
    <section id="packages" className="px-6 md:px-12 py-24 md:py-32 max-w-[1600px] mx-auto">
      <Reveal>
        <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#F5B301] mb-6">01 — Lesson Prices</p>
        <h2 className="font-cabinet font-black uppercase tracking-tighter text-4xl md:text-6xl leading-[0.95] max-w-3xl text-[#f5f5f0]">
          Designed for life. <span className="text-[#F5B301]">Not just the test.</span>
        </h2>
        <p className="font-script text-2xl md:text-3xl text-white/60 mt-6 -rotate-1">Because learning to drive is only the beginning.</p>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6 mt-16">
        {packages.map((pkg, i) => (
          <Reveal key={pkg.name} delay={i * 0.1}>
            <div
              data-testid={`package-card-${pkg.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className={`group relative border p-8 h-full flex flex-col transition-[box-shadow,transform] duration-300 hover:-translate-y-1 ${
                pkg.featured
                  ? "bg-[#F5B301] text-[#0a0a0a] border-[#F5B301] shadow-[8px_8px_0_#f5f5f0] hover:shadow-[12px_12px_0_#f5f5f0]"
                  : "bg-[#111113] text-[#f5f5f0] border-white/20 hover:shadow-[8px_8px_0_#F5B301]"
              }`}
            >
              {pkg.featured && (
                <span className="absolute -top-4 left-8 bg-[#0a0a0a] text-[#F5B301] text-xs font-bold uppercase tracking-widest px-4 py-2">
                  Best Value
                </span>
              )}
              <h3 className="font-cabinet font-black uppercase tracking-tighter text-2xl">{pkg.name}</h3>
              <div className="flex items-end gap-2 mt-6">
                <span className="font-cabinet font-black text-6xl tracking-tighter">{pkg.price}</span>
                <span className={`text-sm uppercase tracking-widest mb-2 ${pkg.featured ? "text-black/60" : "text-white/50"}`}>
                  {pkg.per}
                </span>
              </div>
              <ul className="mt-8 space-y-4 flex-1">
                {pkg.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-3 text-sm leading-relaxed">
                    <Check className={`w-4 h-4 mt-0.5 shrink-0 ${pkg.featured ? "text-[#0a0a0a]" : "text-[#F5B301]"}`} strokeWidth={3} />
                    <span className={pkg.featured ? "text-black/80" : "text-white/70"}>{feature}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#book"
                data-testid={`package-book-btn-${pkg.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className={`mt-10 text-center font-bold uppercase tracking-wide text-sm px-6 py-4 transition-colors duration-300 ${
                  pkg.featured
                    ? "bg-[#0a0a0a] text-[#F5B301] hover:bg-[#f5f5f0] hover:text-[#0a0a0a]"
                    : "border-2 border-[#f5f5f0] hover:bg-[#F5B301] hover:text-[#0a0a0a] hover:border-[#F5B301]"
                }`}
              >
                Book Now
              </a>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="text-white/50 text-sm leading-relaxed mt-12 max-w-3xl border-l-2 border-[#F5B301] pl-6" data-testid="packages-inclusions-note">
          Every lesson includes pick-up &amp; drop-off, lesson debrief, goal setting and parent feedback. Every first Odd Hour Lesson comes with a complimentary 30-minute parent &amp; learner chat — before we even turn the key.
        </p>
      </Reveal>
    </section>
  );
}
